export default {
  homepage: 'payments',
  url: 'http://admin-staging.maya.tech:4401',
  apiUrl: '',
  devUrl: 'http://admin-staging.maya.tech:4401',
  assets: {
    paymentAssetsLink: '',
    productLink: 'https://atm.cm',
    receiptLink: '',
    screenLink: '',
    cameraTestLink: 'https://atm.cm/assets/',
    fsLink: '',
    userAvatarLink: 'https://sso.maya.tech/media/'
  },
  sso: {
    url: 'https://sso.maya.tech',
    clientId: ''
  },
  google: { // unused
    key: 'AIzaSyAA_Mg-A-zh40jtCfsfLJBK3lHuc5tLf8I'
  },
  exporter: {
    link: '/export/'
  },
  webDocs: {
    link: ''
  },
  transpayment2: {
    key: '*SWX$%)==WKLDC4WSD%X?";@3!4XWE',
    agentId: 5798
  }
}



// WEBPACK FOOTER //
// ./src/config/client.js